/* ENGRAM · página de texto (ecrã 3a, sections/engram-text-page)
   Marca no índice (coluna do desktop e botões do telemóvel) a parte que está a ser lida e, no telemóvel,
   desliza a fila de botões até ao botão marcado. Sem JS, o índice continua a funcionar como links.

   A parte marcada é a última cujo título já passou a linha de leitura: o sítio onde um título fica depois de um
   clique no índice (scroll-margin-top) mais uma margem. No fim da página marca-se a última parte, que pode não
   chegar a subir até à linha. Ao clicar, marca-se logo o item clicado e a marcação espera que o deslize acabe. */
(function () {
  var READ_MARGIN = 48; // px abaixo do scroll-margin-top do título

  function init(root) {
    if (root.dataset.engramTextReady) return;
    root.dataset.engramTextReady = '1';
    var anchors = Array.prototype.slice.call(root.querySelectorAll('[data-engram-text-anchor]'));
    if (!anchors.length) return;
    var links = Array.prototype.slice.call(root.querySelectorAll('.engram-text-page__index-link, .engram-text-page__chip'));
    var current = null;
    var lockUntil = 0;
    var ticking = false;

    function mark(id) {
      if (id === current) return;
      current = id;
      links.forEach(function (link) {
        var on = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-on', on);
        if (on) {
          link.setAttribute('aria-current', 'location');
          var row = link.closest('.engram-text-page__chips');
          if (row && row.offsetParent !== null) {
            var left = link.offsetLeft - (row.clientWidth - link.offsetWidth) / 2;
            row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function update() {
      ticking = false;
      if (Date.now() < lockUntil) return;
      var line = (parseFloat(getComputedStyle(anchors[0]).scrollMarginTop) || 0) + READ_MARGIN;
      var doc = document.documentElement;
      if (window.innerHeight + window.pageYOffset >= doc.scrollHeight - 2) {
        // no fim da página: a última parte com o título à vista
        for (var k = anchors.length - 1; k >= 0; k--) {
          if (anchors[k].getBoundingClientRect().top < window.innerHeight) { mark(anchors[k].id); return; }
        }
      }
      var id = anchors[0].id;
      for (var i = 0; i < anchors.length; i++) {
        if (anchors[i].getBoundingClientRect().top <= line) id = anchors[i].id; else break;
      }
      mark(id);
    }

    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    root.addEventListener('engram:text-jump', function (e) {
      mark(e.detail.id);
      lockUntil = Date.now() + 900; // o deslize suave dura menos do que isto; depois o scroll volta a mandar
      window.setTimeout(update, 950);
    });
    update();
  }

  /* Cliques no índice: os links têm data-no-smooth, para o deslize do tema (global.js) não os apanhar — ele desce até ao
     topo exacto do título e deixa-o por baixo do header fixo. Aqui o scrollIntoView respeita o scroll-margin-top do título. */
  function bindLinks(root) {
    if (root.dataset.engramTextLinks) return;
    root.dataset.engramTextLinks = '1';
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-engram-text-link]');
      if (!link) return;
      var id = (link.getAttribute('href') || '').slice(1);
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      root.dispatchEvent(new CustomEvent('engram:text-jump', { detail: { id: id } }));
    });
  }

  function boot() {
    document.querySelectorAll('[data-engram-text-page]').forEach(function (root) { bindLinks(root); init(root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
